export default "__VITE_ASSET__DSJ0r_mc__"